// extracted by mini-css-extract-plugin
export default {"headingMainContainer":"PageTitleWithLeaf_headingMainContainer__5k6wg","pageTitle":"PageTitleWithLeaf_pageTitle__vVWXl","leafImage":"PageTitleWithLeaf_leafImage__ccc-Z"};